import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from './App';

import { ThemeProvider } from './app/providers/ThemeProvider';
import { AuthProvider } from './app/providers/AuthProvider';
import { EmpresaProvider } from './app/providers/EmpresaProvider';

async function enableMocking() {
  // Solo activamos MSW en el entorno de desarrollo
  if (process.env.NODE_ENV !== 'development') {
    return;
  }
  
  const { worker } = await import('./mocks/browser');
  
  // onUnhandledRequest: 'bypass' evita que la consola se llene de advertencias 
  // por peticiones a imágenes, fuentes u otros recursos que no estamos mockeando.
  return worker.start({
    onUnhandledRequest: 'bypass',
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));

function RootApp() {
  return (
    <AuthProvider>
      <EmpresaProvider>
        <App />
      </EmpresaProvider>
    </AuthProvider>
  );
}

const router = createBrowserRouter([
  {
    path: "*",
    element: <RootApp />,
  },
]);

// Llamamos a la función y ESPERAMOS a que termine antes de renderizar
enableMocking().then(() => {
  root.render(
    <React.StrictMode>
      <ThemeProvider>
        <RouterProvider router={router} />
      </ThemeProvider>
    </React.StrictMode>
  );
});
